import { UserRoles } from '../../services/auth.service';

/**
 * Wer die Credit-Verbrauchsseite sieht.
 *
 * Die Seite gehoert dem KUNDEN: ein Kunden-Admin sieht den Verbrauch seines
 * eigenen Mandanten, super_admin jeden Mandanten oder alle zusammen. Die
 * Mandantengrenze erzwingt das Backend (`credit_analytics_endpoints.py`),
 * nicht dieses Flag — hier geht es nur darum, wem Menue und Route angezeigt
 * werden.
 *
 * Fuer Kunden-Admins freigegeben am 05.10.2026. Der Schalter gehoert zu
 * `_SUPER_ADMIN_ONLY` im Backend und zur Umgebungsvariable
 * `CREDIT_ANALYTICS_CUSTOMER_RELEASE` am LangGraph-Server — immer alle drei
 * zusammen umlegen, sonst zeigt das Portal eine Seite, deren Anfragen mit
 * 403 enden.
 */
export const CREDIT_ANALYTICS_CUSTOMER_RELEASE = true;

/** Credits sind Abrechnungsdaten: dieselbe Rolle, die Credits kaufen darf.
 *  Bewusst nicht `manager`. */
export const CREDIT_ANALYTICS_ROLES: string[] = CREDIT_ANALYTICS_CUSTOMER_RELEASE
  ? [UserRoles.SuperAdmin, UserRoles.Admin]
  : [UserRoles.SuperAdmin];

export function canSeeCreditAnalytics(role: string | undefined | null): boolean {
  return !!role && CREDIT_ANALYTICS_ROLES.includes(role);
}
